"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const Creatable_1 = __importDefault(require("react-select/lib/Creatable"));
const classnames_1 = __importDefault(require("classnames"));
const isString_1 = __importDefault(require("lodash/isString"));
const prop_types_1 = __importDefault(require("prop-types"));
const select_components_1 = require("../select-components");
require("../../../styles/components/react-select/react-select.less");
const addOption = { label: '+ Create New', value: 'createNewOption', className: 'option-link' };
const mapStringOption = (option) => ({ value: option, label: option });
const DefaultDropdown = (props) => {
    const { options, enableAddOption, selected, maxItemsToRender, placeholder, label, onValueChange, isValid, className, isDisabled, showOnTop, styles, MultiValueContainer, Control: ControlComp, MultiValue, isCreatable, Option, SingleValue: CustomSingleValue, MenuList: MenuListComp, ...otherProps } = props;
    const { isSearchable: isSearchableProps } = otherProps;
    const components = (0, react_1.useMemo)(() => ({
        Control: ControlComp || select_components_1.Control,
        Option: Option || select_components_1.NameDescOption,
        DropdownIndicator: otherProps.DropdownIndicator ?? select_components_1.DropdownIndicator,
        SingleValue: CustomSingleValue || select_components_1.SingleValue,
        MenuList: MenuListComp || select_components_1.MenuList,
    }), [ControlComp, CustomSingleValue, MenuListComp, Option, otherProps.DropdownIndicator]);
    const getOptions = (0, react_1.useCallback)(() => {
        const dropdownOptions = options.map((option) => {
            if ((0, isString_1.default)(option)) {
                return mapStringOption(option);
            }
            return option;
        });
        if (enableAddOption) {
            return [addOption, ...dropdownOptions];
        }
        return dropdownOptions;
    }, [options, enableAddOption]);
    const selectedOption = (0, react_1.useCallback)(() => ((0, isString_1.default)(selected) ? mapStringOption(selected) : selected), [selected]);
    const addedProps = (0, react_1.useMemo)(() => {
        if (!showOnTop) {
            return {};
        }
        return {
            styles: { ...styles, menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
            menuPortalTarget: document.body,
        };
    }, [showOnTop, styles]);
    const isSearchable = (0, react_1.useMemo)(() => {
        let isSearchableValue = isSearchableProps;
        if (options && options.length > maxItemsToRender) {
            isSearchableValue = true;
        }
        return isSearchableValue !== undefined ? isSearchableValue : false;
    }, [isSearchableProps, maxItemsToRender, options]);
    const renderProps = (0, react_1.useMemo)(() => ({
        className: (0, classnames_1.default)('react-select-dropdown-container', { [className]: className }),
        options: getOptions(),
        value: selectedOption(),
        onChange: onValueChange,
        placeholder: placeholder || (!label && 'Select Option'),
        label,
        components,
        isValid: isValid !== undefined ? isValid : true,
        isSearchable,
        isDisabled: isDisabled !== undefined ? isDisabled : false,
        maxItemsToRender,
        styles,
        ...otherProps,
        ...addedProps,
    }), [addedProps, className, components, getOptions, isDisabled, isSearchable, isValid, label, maxItemsToRender, onValueChange, otherProps, placeholder, selectedOption, styles]);
    if (!options)
        return react_1.default.createElement("div", null);
    if (isCreatable) {
        return (react_1.default.createElement(Creatable_1.default, { ...renderProps }));
    }
    return (react_1.default.createElement(react_select_1.default, { ...renderProps }));
};
DefaultDropdown.defaultProps = {
    isCreatable: false,
    enableAddOption: false,
    maxItemsToRender: 400,
    onValueChange: undefined,
    classNamePrefix: 'react-select-dropdown',
    showOnTop: false,
    styles: {},
    placeholder: '',
    isSearchable: false,
    isValid: false,
    isDisabled: false,
    selected: undefined,
    searchMessage: '',
};
const labelPropTypes = prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]);
const selectedPropType = prop_types_1.default.shape({
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]).isRequired,
    label: labelPropTypes.isRequired,
    icon: prop_types_1.default.string,
});
DefaultDropdown.propTypes = {
    selected: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        selectedPropType,
        prop_types_1.default.arrayOf(selectedPropType),
    ]),
    options: prop_types_1.default.arrayOf(prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.shape({
            value: prop_types_1.default.any,
            label: labelPropTypes,
            desc: prop_types_1.default.string,
            options: prop_types_1.default.arrayOf(prop_types_1.default.shape({
                value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]).isRequired,
                label: prop_types_1.default.string.isRequired,
                desc: prop_types_1.default.string,
            })),
        }),
    ])).isRequired,
    placeholder: prop_types_1.default.string,
    onValueChange: prop_types_1.default.func,
    isSearchable: prop_types_1.default.bool,
    isValid: prop_types_1.default.bool,
    isDisabled: prop_types_1.default.bool,
    isCreatable: prop_types_1.default.bool,
    enableAddOption: prop_types_1.default.bool,
    searchMessage: prop_types_1.default.string,
    maxItemsToRender: prop_types_1.default.number,
    classNamePrefix: prop_types_1.default.string,
    showOnTop: prop_types_1.default.bool,
    styles: prop_types_1.default.object,
};
exports.default = DefaultDropdown;
//# sourceMappingURL=default-dropdown.js.map